import { AxiosResponseType } from '../../types/axiosTypes';
import api from '../axios';
import { fetchAuthSession } from '@aws-amplify/core';

export const setupCompanyMessagingBrand = async (
  companyId: string,
  payload: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();

  if (tokens) {
    const idToken = tokens.idToken?.toString();

    const res = await api.post<AxiosResponseType>(
      `/messaging/company/${companyId}/setup_brand`,
      {
        token: idToken,
        payload: payload,
      }
    );

    return res.data;
  } else {
    throw new Error('User Not found');
  }
};

export const syncCompanyMessagingBrand = async (
  companyId: string
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();

  if (tokens) {
    const idToken = tokens.idToken?.toString();

    const res = await api.post<AxiosResponseType>(
      `/messaging/company/${companyId}/sync_brand`,
      {
        token: idToken,
      }
    );

    return res.data;
  } else {
    throw new Error('User Not found');
  }
};
